<h3>{{ 'lienAdditionalInformation.additionalInformation' | transloco }}</h3>
<div class="flex-container">
    {{ order.lien?.additionalInformation }}
</div>